import {
  SERVICE_STAFF_ROLES,
  SERVICE_STAFF_AND_CLIENT_ROLES,
} from "@west-tennessee-consulting/hub-roles";

export const TIME_ENTRY_METADATA_FIELDS = {
created_at: {
    type: "datetime",
    label: "Created",
    autoFill: true,
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: false, // Now editable with date picker
    width: 160,
    minWidth: 120,
    maxWidth: 220,
    icon: "Calendar",
    datetimePresets: {
      enabled: true,
      presets: [
        "today",
        "yesterday",
        "last7days",
        "last30days",
        "thismonth",
        "lastmonth",
        "thisyear",
        "lastyear",
      ] as string[],
      showCustomRange: true,
    },
    // Internal audit timestamp — staff only.
    allowedRoles: [...SERVICE_STAFF_ROLES] as string[],
    mobileDetailSectionId: "metadata",
  },
updated_at: {
    type: "datetime",
    label: "Updated",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: false, // Now editable with date picker
    width: 160,
    minWidth: 120,
    maxWidth: 220,
    icon: "Calendar",
    datetimePresets: {
      enabled: true,
      presets: [
        "today",
        "yesterday",
        "last7days",
        "last30days",
        "thismonth",
        "lastmonth",
        "thisyear",
        "lastyear",
      ] as string[],
      showCustomRange: true,
    },
    // Internal audit timestamp — staff only.
    allowedRoles: [...SERVICE_STAFF_ROLES] as string[],
    mobileDetailSectionId: "metadata",
  }
} as const;
